import { bodyMedium } from '@payflip/ui';
import styled from 'styled-components';

export const Field = styled.div``;

export const Error = styled.p`
  ${bodyMedium};

  font-style: italic;
  color: ${({ theme }): string => theme.palette_alert_50};
  margin: 0;
`;
